<template>
  <div id="header">
    <nav class="navbar navbar-default navbar-fixed-top">
      <div class="container-fluid wrap">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <button id="navButton" type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
<!--          <a class="navbar-brand" href="#/home">-->
<!--            <img src="@/assets/img/logo_big.png">-->
<!--          </a>-->
        </div>
        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav main-nav navbar-right">
            <li
              v-for="(item,index) in navList"
              :key="index"
              :class="index===navIndex? item.children.length>0 ? 'dropdown active': 'active' : item.children.length>0 ? 'dropdown': ''"
              @click="navClick(index,item.name)"
            >
              <router-link :to="item.path">
                {{item.name}}
                <!-- <span class="caret" v-if="item.children.length>0"></span> -->
              </router-link>
              <!-- <ul v-if="item.children.length>0" class="dropdown-menu">
                <li v-for="(i,n) in item.children" :key="n">
                  <router-link :to="i.path">{{i.name}}</router-link>
                </li>
              </ul> -->
            </li>
          </ul>
        </div><!-- /.navbar-collapse -->
      </div><!-- /.container-fluid -->
    </nav>
  </div>
</template>
<script>
import config from '@/config'
export default {
  name: "Header",
  data() {
    return {
      config: config,
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "Home",
      navList: [
        {
          name: "Home",
          path: "/",
          children: []
        },
        {
          name: "Legal",
          path: "/legal/termService",
          children: [
            // {
            //   name: "Term of Service",
            //   path: "/legal/termService"
            // },
            // {
            //   name: "Privacy Policy",
            //   path: "/legal/privacyPolicy"
            // },
            // {
            //   name: "Refund Policy",
            //   path: "/legal/refundPolicy"
            // },
            // {
            //   name: "Cookie Policy",
            //   path: "/legal/cookiePolicy"
            // }
          ]
        },
        {
          name: "Contact Us",
          path: "/contactUs",
          children: []
        },
      ]
    };
  },
  mounted() {
    this.navClick(0, "Home")
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    }
  }
};
</script>
<style scoped>
#header{
  /* margin-bottom: 100px; */
}
/*手机*/

@media (max-width: 767px) {
  /* #header{
    margin-bottom: 50px;
  } */
}
/*平板*/

@media (min-width:768px) and (max-width: 992px) {
  /* #header{
    margin-bottom: 100px;
  } */
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue